import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const MembersIcon: FC<IconProps> = ({ fill, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} fill={fill}>
    <path
      d="M24.7,5a1.54,1.54,0,0,1,1.5,1.5,1.5,1.5,0,0,1-3,0A1.54,1.54,0,0,1,24.7,5m0-2a3.54,3.54,0,0,0-3.5,3.5,3.5,3.5,0,0,0,7,0A3.54,3.54,0,0,0,24.7,3Z"
      fill="current"
    />
    <path
      d="M24.7,14.5a3.22,3.22,0,0,1,2.6,1.2,3.58,3.58,0,0,1,.8,2.8l-.1.9H26.5l-.2,1.8L25.6,27H23.7l-.6-5.9v-.4l.2-1.2a7.63,7.63,0,0,0-.5-4.5,4.14,4.14,0,0,1,1.9-.5m0-2a5.59,5.59,0,0,0-4.4,2.2,6.11,6.11,0,0,1,1,4.6L21,20.8a1.42,1.42,0,0,1-.2.6h.3l.6,6.1A1.65,1.65,0,0,0,23.4,29h2.4a1.73,1.73,0,0,0,1.7-1.5l.6-6.1h.1a1.51,1.51,0,0,0,1.5-1.2l.2-1.3a5.25,5.25,0,0,0-5.2-6.4Z"
      fill="current"
    />
    <path
      d="M16,10a5,5,0,0,1-5-5A5,5,0,0,1,21,5,5,5,0,0,1,16,10Zm0-8a3,3,0,0,0-3,3,3,3,0,0,0,6,0A3,3,0,0,0,16,2Z"
      fill="current"
    />
    <path
      d="M17.4,32H14.6a2.86,2.86,0,0,1-2.9-2.7L11,23.1a2.57,2.57,0,0,1-1.9-2.2l-.3-1.5a7,7,0,0,1,1.6-5.9A7.44,7.44,0,0,1,16,10.9a7.12,7.12,0,0,1,5.6,2.6,7,7,0,0,1,1.6,5.9l-.3,1.5A2.71,2.71,0,0,1,21,23.1l-.7,6.3A2.85,2.85,0,0,1,17.4,32ZM16,12.9a5.12,5.12,0,0,0-4,1.9,5.6,5.6,0,0,0-1.2,4.3l.3,1.5a.73.73,0,0,0,.7.6H12a1.06,1.06,0,0,1,1,.9l.7,7.1a.9.9,0,0,0,.9.9h2.8a.9.9,0,0,0,.9-.9l.7-7.1a1.06,1.06,0,0,1,1-.9h.2a.67.67,0,0,0,.7-.6l.3-1.5A5.23,5.23,0,0,0,20,14.8,5.12,5.12,0,0,0,16,12.9Z"
      fill="current"
    />
    <path
      d="M7.4,5A1.54,1.54,0,0,1,8.9,6.5,1.45,1.45,0,0,1,7.4,7.9,1.45,1.45,0,0,1,5.9,6.5,1.47,1.47,0,0,1,7.4,5m0-2A3.48,3.48,0,0,0,3.9,6.5,3.54,3.54,0,0,0,7.4,10a3.54,3.54,0,0,0,3.5-3.5A3.54,3.54,0,0,0,7.4,3Z"
      fill="current"
    />
    <path
      d="M7.4,14.5a3.29,3.29,0,0,1,1.9.6,7.72,7.72,0,0,0-.5,4.5L9,20.8v.4L8.3,27H6.4l-.6-5.9-.2-1.8H4.1L4,18.5a3.24,3.24,0,0,1,.8-2.8,3.09,3.09,0,0,1,2.6-1.2m0-2A5.49,5.49,0,0,0,2,18.9l.2,1.3a1.43,1.43,0,0,0,1.5,1.2h.1l.6,6.1A1.81,1.81,0,0,0,6.1,29H8.5a1.73,1.73,0,0,0,1.7-1.5l.6-6.1h.4a1.45,1.45,0,0,1-.2-.7l-.3-1.5a6.11,6.11,0,0,1,1-4.6,5.31,5.31,0,0,0-4.3-2.1Z"
      fill="current"
    />
  </svg>
);
